function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Combined Shape");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Courses",
  stroke: "none",
  strokeWidth: 1,
  fill: "currentColor",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Edit-Course-Effort",
  transform: "translate(-27.000000, -477.000000)",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M33,477 C36.3084814,477 39,479.664809 39,482.940458 C39,485.999861 34.1250938,491.703265 33.5696773,492.34383 L33.5696773,492.34383 L33,493 L32.4303227,492.34383 C31.8749062,491.703265 27,485.999861 27,482.940458 C27,479.664809 29.6915186,477 33,477 Z M33,478.486229 C30.518639,478.486229 28.5011258,480.484464 28.5011258,482.940458 C28.5011258,484.824997 31.3630223,488.704055 33,490.698574 C34.6369777,488.703312 37.4988742,484.822767 37.4988742,482.940458 C37.4988742,480.484464 35.481361,478.486229 33,478.486229 Z M33,480 C34.6545,480 36,481.34625 36,483 C36,484.6545 34.6545,486 33,486 C31.3455,486 30,484.6545 30,483 C30,481.34625 31.3455,480 33,480 Z M33,481.5 C32.17275,481.5 31.5,482.1735 31.5,483 C31.5,483.828 32.17275,484.5 33,484.5 C33.82725,484.5 34.5,483.828 34.5,483 C34.5,482.1735 33.82725,481.5 33,481.5 Z",
  id: "Combined-Shape"
})));

var SvgIconLocations = function SvgIconLocations(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconLocations, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-locations.bea8ed0d.svg";
export { ForwardRef as ReactComponent };